/**
 * @typedef {import("../../definitions/GoogleMapsApiTypes").GMapsCoords} CoordsData
 */

import { getDrupalSetting } from '@ggs/utils'

/**
 * A query function to get the coordinates given some address data
 * @param {number} lat - latitude coordinate
 * @param {number} lng - longitude coordinate
 * @return {Promise<CoordsData>}
 */
const getAddress = async (lat, lng) => {
  const apiKey = getDrupalSetting('mapsApiKey') || `${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
  const urlParams = encodeURI(`latlng=${lat},${lng}&key=${apiKey}`)

  const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?${urlParams}`, {
    method: 'GET',
    mode: 'cors',
  })

  const data = await response.json()

  if (!response.ok) {
    throw new Error('Unknown error, try again later')
  } else if (data.status === 'OK') {
    /** @type {google.maps.GeocoderResult} */
    const results = data.results[0]
    const postalCodeItem = results.address_components.find(
      (component) => component.types[0] === 'postal_code'
    )

    return /** @type {CoordsData} */ {
      address: data.results[0].formatted_address,
      postalCode: postalCodeItem ? postalCodeItem.short_name : null,
      ...data.results[0].geometry.location,
    }
  } else if (data.status === 'ZERO_RESULTS') {
    return /** @type {CoordsData} */ {
      address: '',
      postalCode: null,
      lat: null,
      lng: null,
    }
  } else {
    throw new Error(data.error_message ?? 'Unknown error, try again later')
  }
}

export default getAddress
